import { CallToActionBrandProps } from 'modules/BrandDefinition';
import { LexicalCallToActionEditor } from 'modules/Lexical/components/LexicalCallToActionEditor';
import { HistoryPluginChangeHandler } from 'modules/Lexical/Plugins/HistoryWithExtraStatePlugin';
import React, { ComponentPropsWithRef, createContext, ReactNode, useContext } from 'react';
import { HistoryExtraStateHook } from '../hooks/useHistoryExtraState';

type EditorProps = ComponentPropsWithRef<typeof LexicalCallToActionEditor>;

type ContextType = {
  editorState: EditorProps['editorState'];
  editorRef: Exclude<EditorProps['ref'], undefined>;
  onChange: EditorProps['onChange'];
  onStopEditing: EditorProps['onStopEditing'];
  id: string;
  cssButton: string;
  editMode: boolean;
  editorWrap: React.RefObject<HTMLDivElement>;
  returnFocusToEditor: () => void;
  styles: React.CSSProperties;
  brandProps: CallToActionBrandProps;
  history: HistoryExtraStateHook;
  historyOnChange: HistoryPluginChangeHandler;
};

const Context = createContext<ContextType | null>(null);

export const useLexicalCTAEditorContext = (): ContextType => {
  const value = useContext(Context);

  if (!value) {
    throw new Error('must be used within a LexicalCTAEditorProvider');
  }

  return value;
};

type ProviderProps = {
  value: ContextType;
  children: ReactNode;
};

export const LexicalCTAEditorProvider: React.FC<ProviderProps> = ({ children, value }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
